import React from 'react'
import PropTypes from 'prop-types';
import _ from 'lodash'

import I18n from 'PMT/i18n/I18n'
import Utils from 'PMT/utils/Utils'
import ArrayUtils from 'PMT/utils/ArrayUtils'

import ConditionRulesList from './ConditionRulesList'
import ItemSelectorModal from 'components/menu/ItemSelectorModal/ItemSelectorModal'

const Btn = ({ onChange, conditionRules }) => (
  <div
    className="btn btn-primary btn-add"
    onClick={() => onChange([...conditionRules, {
      id: Utils.generateUID(),
      itemsNumber: 0,
      itemsList: [],
      // itemsList: [{
      //   type: null,
      //   id: Utils.generateUID(),
      // }]
    }])}
  >
    <i className="fa fa-plus" />&nbsp;{I18n.tr('order.cart_modifiers.conditions_rules.add_rule')}
  </div>
)

class ConditionRules extends React.Component {

  state = {
    displayItemSelector: false,
    conditionRuleToSelectItems: null,
  }

  handleDisplayItemSelector = (conditionRule) => {
    this.setState({
      displayItemSelector: true,
      conditionRuleToSelectItems: conditionRule,
    })
  }

  handleHideItemSelector = () => {
    this.setState({
      displayItemSelector: false,
      conditionRuleToSelectItems: null,
    })
  }

  hanteItemsChangeForConditionRule = (conditionRule, items) => {
    conditionRule.itemsList = items
    this.props.onChange(ArrayUtils.updateObject(this.props.conditionRules, conditionRule, (oldRule) => oldRule.id === conditionRule.id))
    this.handleHideItemSelector()
  }

  render() {
    try {
     const { restaurantMenu, conditionRules, singleMode = false, onChange } = this.props
     return (
       <div>
         {!_.isEmpty(conditionRules) &&
           <ConditionRulesList
             restaurantMenu={restaurantMenu}
             conditionRules={_.clone(conditionRules)}
             onChange={onChange}
             onDisplayItemSelector={this.handleDisplayItemSelector}
           />
         }

         {/* display button if we are not in single mode or single dont have action yet */}
         {!singleMode &&
           <Btn
             onChange={onChange}
             conditionRules={conditionRules}
           />
         }

         {singleMode && _.isEmpty(conditionRules) &&
           <Btn
             onChange={onChange}
             conditionRules={conditionRules}
           />
         }

         {this.state.displayItemSelector &&
           <ItemSelectorModal
             show
             onHide={this.handleHideItemSelector}
             restaurantMenu={restaurantMenu}
             values={this.state.conditionRuleToSelectItems.itemsList || []}
             onChange={(items) => this.hanteItemsChangeForConditionRule(this.state.conditionRuleToSelectItems, items)}
           />
         }
       </div>
    ) } catch (e) { console.error(e) }
  }
}

ConditionRules.propTypes = {
  restaurantMenu: PropTypes.object.isRequired,
  conditionRules: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,

  // Target contains not an array but an object
  singleMode: PropTypes.bool,
}

export default ConditionRules
